// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__3j0QC","options":"AnswerScale_options__1nKWF","selected":"AnswerScale_selected__16jJy"};